<template>
  <div class="shop-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div v-if="!map" class="shop-page__container">
      <div class="shop-page__info sides-padding">
        <div class="container">
          <a @click="map = true" class="btn btn--sd btn--map btn--with-icon">
            <IconComponent name="map-1" />
            <span class="text">Посмотреть на карте</span>
          </a>
          <div v-for="(item, i) in shops" :key="i" class="shop-page__info-item">
            <div class="shop-page__info-item__left">
              <ImgComponent class="image" :head_img="item.img" />
            </div>
            <div class="shop-page__info-item__right">
              <span class="title">{{ item.title }}</span>
              <ShopContactsComponent :data="item" />
              <span class="subtitle">{{ item.description }}</span>
              <div class="shop-page__info-item__buttons">
                <router-link
                  :to="{
                    name: 'shop_item',
                    params: { id: item.id },
                  }"
                  class="btn btn--gray btn--md btn--with-icon"
                >
                  <span>Подробнее</span>
                  <IconComponent name="arrow-right-1" />
                </router-link>
                <router-link :to="{ name: 'catalog' }" class="btn btn--main btn--md btn--with-icon">
                  <span>Смотреть все товары</span>
                  <IconComponent name="arrow-right-1" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PaginationComponent
        :page="page"
        :total="Math.ceil(total / first)"
        @change="reload"
        v-if="Math.ceil(total / first) > 1"
      />
    </div>
    <div v-if="map" class="shop-page__map">
      <div class="container">
        <a @click="map = false" class="btn btn--sd btn--map btn--with-icon">
          <IconComponent name="map-1" />
          <span class="text">Закрыть карту</span>
        </a>
        <MapLocationsComponent :addresses="addresses" />
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import SHOP_PAGE from "@/graphql/pages/ShopPage.graphql";
import ImgComponent from "components/ImgComponent.vue";
import IconComponent from "components/IconComponent.vue";
import ShopContactsComponent from "../components/ShopContactsComponent.vue";
import MapLocationsComponent from "components/MapLocationsComponent.vue";
import PaginationComponent from "components/Pagination.vue";

export default {
  name: "ShopPage",
  async asyncData({ apollo, store }) {
    await apollo.defaultClient
      .query({
        query: SHOP_PAGE,
        variables: {
          first: 2,
        },
      })
      .then(({ data }) => {
        store.state.shop_page.shops = data.baby_shops_paginate;
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  },
  components: {
    PaginationComponent,
    MapLocationsComponent,
    ShopContactsComponent,
    BreadcrumbsComponent,
    ImgComponent,
    IconComponent,
  },
  data() {
    return {
      map: false,
      first: 2,
      page: 1,
      addresses: [
        {
          address: this.$store.state.shop_page.shops.data[0].address,
        },
        {
          address: this.$store.state.shop_page.shops?.data[1]?.address,
        },
      ],
      benefits: [
        {
          title: "Работаем по всей России",
        },
        {
          title: "Широкий ассортимент",
        },
        {
          title: "Бесплатная школа мам",
        },
        {
          title: "Персональная помощь",
        },
        {
          title: "Сервисное обслуживание",
        },
        {
          title: "Официальный дистрибьютор",
        },
        {
          title: "Круглосуточная работа",
        },
        {
          title: "Скидки и Акции",
        },
      ],
    };
  },
  methods: {
    async reload(page = 1) {
      await this.$apolloProvider.defaultClient
        .query({
          query: SHOP_PAGE,
          variables: {
            page: page,
            first: this.first,
          },
        })
        .then(({ data }) => {
          this.$store.state.shop_page.shops = data.baby_shops_paginate;
          this.$store.state.all_brands = data.brands || [];
          this.$store.state.popular_brands = data.brands_paginate.data || [];
          this.$store.state.categories = data.header_categories.data || [];
          this.$store.state.pages = data.pages;
          this.$store.state.marketplace = data.marketplace;
          this.page = page;
          this.addresses[0].address = data.baby_shops_paginate.data[0].address;
          if (data.baby_shops_paginate.data[1]) {
            this.addresses[1].address = data.baby_shops_paginate.data[1].address;
          } else {
            this.addresses[1].address = null;
          }
        });
    },
  },
  mounted() {
    if (this.$route.hash) {
      document.querySelector(this.$route.hash).scrollIntoView({ block: "start", behavior: "smooth" });
    }
  },
  computed: {
    links() {
      return [{ title: "Магазины" }];
    },
    shops() {
      return this.$store.state.shop_page.shops.data;
    },
    total() {
      return this.$store.state.shop_page.shops.paginatorInfo.total;
    },
  },
  metaInfo: {
    title: "Магазины",
  },
};
</script>

<style lang="stylus">
.shop-page {
  width 100%
  display grid
  grid-gap 30px

  &__container {
    display grid
    align-items start
    gap 50px

    .btn--map {
      margin-bottom 0
    }
  }

  &__info {
    .container {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }
    .image {
      //max-width 605px
      max-height 450px
      border-radius 15px
    }
    .title {
      display: flex;
      font-weight: 700;
      font-size: 1.5em;
      line-height: 115%;
      margin-bottom: 30px;
    }

    .subtitle {
      display: flex;
      margin-top: 30px;
      margin-bottom 30px
      font-size 1em
      line-height: 170%
    }

    &-item {
      display grid
      grid-template-columns 1fr 1fr
      grid-gap 30px
      background: var(--gray_o3)
      border-radius: var(--main_radius)
      padding 30px
      +below(1030px) {
        display flex
      flex-direction column
      //width 69%
      }

      &__buttons {
        display flex
        gap 16px
        flex-wrap wrap

        .btn {
          +below(530px) {
            flex-grow 1
          }
        }
      }
    }
  }

  &__map {
    padding 0 15px
    .map {
      border-radius: var(--main_radius)
      overflow: hidden
      width 100%
      height 100vh
      max-height 901px
      margin-top 30px
    }
  }

  .btn--map {
    display flex
    gap 5px
    text-transform none
    justify-content flex-end
    //margin-bottom 30px

    .text {
      text-decoration underline
    }
  }
}
</style>
